export const ClientIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="-1 -1 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 17V16C1 12.134 4.13401 9 8 9C11.866 9 15 12.134 15 16V17"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9C10.2091 9 12 7.2091 12 5C12 2.79086 10.2091 1 8 1C5.79086 1 4 2.79086 4 5C4 7.2091 5.79086 9 8 9Z"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
